import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "megafon-ui"
    }}>{`megafon-ui`}</h1>
    <p>{`MegaFon React UI components library.`}</p>
    <p><a parentName="p" {...{
        "href": "https://lerna.js.org/"
      }}><img alt="lerna" src="https://img.shields.io/badge/maintained%20with-lerna-cc00ff.svg" /></a>{`
`}<a parentName="p" {...{
        "href": "http://commitizen.github.io/cz-cli/"
      }}><img alt="Commitizen friendly" src="https://img.shields.io/badge/commitizen-friendly-brightgreen.svg" /></a></p>
    <p>{`Documentation can be found `}<a parentName="p" {...{
        "href": "https://ui.megafon.ru/intro"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "how-to-use"
    }}>{`How to use`}</h2>
    <p>{`MegaFon components library consists of the following npm packages:`}</p>
    <ul>
      <li parentName="ul">{`ui-core
`}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@megafon/ui-core/v/latest"
        }}><img alt="npm (scoped with tag)" src="https://img.shields.io/npm/v/@megafon/ui-core/latest?label=%40megafon%2Fui-core" /></a></li>
    </ul>
    <ul>
      <li parentName="ul">{`ui-shared
`}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@megafon/ui-shared/v/latest"
        }}><img alt="npm (scoped with tag)" src="https://img.shields.io/npm/v/@megafon/ui-shared/latest?label=%40megafon%2Fui-shared" /></a></li>
    </ul>
    <ul>
      <li parentName="ul">{`ui-icons
`}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@megafon/ui-icons/v/latest"
        }}><img alt="npm (scoped with tag)" src="https://img.shields.io/npm/v/@megafon/ui-icons/latest?label=%40megafon%2Fui-icons" /></a></li>
    </ul>
    <ul>
      <li parentName="ul">{`ui-helpers
`}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@megafon/ui-helpers/v/latest"
        }}><img alt="npm (scoped with tag)" src="https://img.shields.io/npm/v/@megafon/ui-helpers/latest?label=%40megafon%2Fui-helpers" /></a></li>
    </ul>
    <p>{`Install using commands:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @megafon/ui-core
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @megafon/ui-shared
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @megafon/ui-icons
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @megafon/ui-helpers
`}</code></pre>
    <p>{`UI components from `}<inlineCode parentName="p">{`@megafon/ui-core`}</inlineCode>{` and `}<inlineCode parentName="p">{`@megafon/ui-shared`}</inlineCode>{` packages require CSS custom properties available in
global scope.`}</p>
    <p>{`Add import of those properties in your project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import "@megafon/ui-core/styles/colors.css";
`}</code></pre>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`Follow `}<a parentName="p" {...{
        "href": "https://github.com/MegafonWebLab/megafon-ui/blob/master/CONTRIBUTING.md"
      }}>{`CONTRIBUTING.md`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/MegafonWebLab/megafon-ui/blob/master/CODE_OF_CONDUCT.md"
      }}>{`CODE_OF_CONDUCT.md`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      